import { useNavigate, NavLink } from "react-router-dom";
import { useAuth } from "@/state/AuthContext";
import { trpc } from "@/trpc";
import { Avatar } from "@/components/ui/avatar";

const menuItemClass =
  "block w-full cursor-pointer rounded-sm px-2 py-1.5 text-left text-sm outline-hidden hover:bg-satyrs-blue/20 hover:text-white focus:bg-satyrs-blue/20 focus:text-white";

export function UserAvatar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { data: profile } = trpc.members.profile.getOwnSettings.useQuery();

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return (
    // Pure-CSS hover dropdown (no JS open state) — see MemberNavLinks for why.
    <div className="group relative hidden md:block ml-3">
      <button className="focus:outline-none" aria-label="User menu" aria-haspopup="menu">
        <Avatar src={profile?.photo_url} alt="Your avatar" className="size-8 cursor-pointer" />
      </button>
      <div
        role="menu"
        className="absolute right-0 top-full z-50 w-40 rounded-md border bg-popover p-1 text-popover-foreground shadow-md opacity-0 invisible transition-opacity group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible"
      >
        {/* The bare /profile route redirects to your own profile once auth resolves. */}
        <NavLink
          to={user ? `/profile/${user.username}` : "/profile"}
          role="menuitem"
          className={menuItemClass}
        >
          Profile
        </NavLink>
        <NavLink to="/settings/profile" role="menuitem" className={menuItemClass}>
          Settings
        </NavLink>
        <div className="bg-border -mx-1 my-1 h-px" />
        <button onClick={handleLogout} role="menuitem" className={menuItemClass}>
          Log Out
        </button>
      </div>
    </div>
  );
}
